import { render } from "./OrderItemReport.vue?vue&type=template&id=00e2fd62&scoped=true"
import script from "./OrderItemReport.vue?vue&type=script&lang=js"
export * from "./OrderItemReport.vue?vue&type=script&lang=js"

import "./OrderItemReport.vue?vue&type=style&index=0&id=00e2fd62&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e2fd62"]])

export default __exports__